module.exports = __webpack_public_path__ + "static/media/mohanrangan.ad7c7268.png";